export default class FeatureSets {
  static PRICING = false;
  static DEMO = false;
}
